var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"canvas",attrs:{"height":"300","width":"350"}})}
var staticRenderFns = []

export { render, staticRenderFns }